import { render, staticRenderFns } from "./myBidding.vue?vue&type=template&id=48be9d00&"
import script from "./myBidding.vue?vue&type=script&lang=js&"
export * from "./myBidding.vue?vue&type=script&lang=js&"
import style0 from "./myBidding.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports